import { Box } from '@terra/ui-styled-system';
import { MarkdownPreview } from '../../../../markdown-preview';

type MarkdownRendererProps = {
  content: string;
  maxHeight?: string;
  showHeader?: boolean;
};

export function MarkdownRenderer({
  content,
  maxHeight,
  showHeader = false,
}: MarkdownRendererProps) {
  return (
    <Box
      bg="bg.canvas"
      p={2}
      borderRadius="sm"
      borderWidth="1px"
      borderColor="border.subtle"
      width="100%"
      maxHeight={maxHeight}
      overflow={maxHeight ? 'auto' : undefined}
      position="relative"
    >
      <MarkdownPreview source={content} fontSize={12} compact />
    </Box>
  );
}
